/**
 * Reverse Stripe card fee math — keep in sync with
 * homecoming-server/app/api/services/stripe_processing_fees.py
 */
export type CardProcessingFeeSchedule = {
  percentFee: number;
  fixedFee: number;
  currency: string;
  country: string;
  label: string;
};

export function calculateProcessingFeeAmount(
  netAmount: number,
  schedule: Pick<CardProcessingFeeSchedule, 'percentFee' | 'fixedFee'>,
): number {
  if (!Number.isFinite(netAmount) || netAmount <= 0) {
    return 0;
  }
  const netMinor = Math.round(netAmount * 100);
  const fixedMinor = Math.round(schedule.fixedFee * 100);
  const grossMinor = Math.ceil(
    (netMinor + fixedMinor) / (1 - schedule.percentFee),
  );
  return (grossMinor - netMinor) / 100;
}
